<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg class="big-icon" style="width: 48px; height: 48px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#info"></use>
          </svg>

          <div class="text mt24">
              <div class="text-size-ml text-bold info-title">Переместить правило?</div>

              <div class="move-rule mt32">
              	<div class="prev cat">
                    {{ sections.from.top }} / {{ sections.from.sect }}
                    <span v-if="sections.from.sub" class="sub">/ {{ sections.from.sub }}</span>
              	</div>
				<svg class="bottom-arrow">
	              <use xlink:href="@/assets/img/big-icons-sprite.svg#bottom-arrow"></use>
	            </svg>
				<div class="next cat">
                    {{ sections.to.top }} / {{ sections.to.sect }}
                    <span v-if="sections.to.sub" class="sub">/ {{ sections.to.sub }}</span>
				</div>
              </div>
          </div>

          <div class="mt32">
              <span class="btn btn--ico" @click="close">Подтвердить</span>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
        name: "MoveRule",
        props: {
            sections: {
                default(){
                    return {
                        from: {
                            top: '',
                            sect: '',
                            sub: false,
                        },
                        to: {
                            top: '',
                            sect: '',
                            sub: false,
                        },
                    }
                }
            }
        },
        methods: {
            close: function () {
                this.$emit('move');
                this.$store.commit('popups/close', {name: this.popups.moveRule.name});
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                blockEdit: state => state.rules.blockEdit,
            }),
        }
    }
</script>

<style scoped>

</style>
